import React from 'react'
import styled from 'styled-components'
import UserIcon from '../../../App/Components/Icons/User/User'
import TicketsIcon from '../../../App/Components/Icons/Tickets/Tickets'
import AvailableOfflineIcon from '../../../App/Components/Icons/AvailableOffline/AvailableOffline'
import HeartIcon from '../../../App/Components/Icons/Heart/Heart'
import { Dark4, WerfenColor, White } from '../../Constants/ColorChart'
import { connect } from 'react-redux'

import isElectron from 'is-electron'
import FeatherIconWrapper from "../Icons/FeatherIconWrapper";
import { DownloadManagerIcon } from "../Icons/DownloadManager/DownloadManager";
// import NotificationIcon from '../../../App/Components/Icons/Notification/Notification'
// import ShoppingBagIcon from '../../../App/Components/Icons/ShoppingBag/ShoppingBag'

const StyledWrapper = styled.div`
    position: fixed;
    width: 60px;
    margin-right: 40px;
    @media screen and (min-width: 992px){
      width: 250px;
    }
`;
const Option = styled.div`
    padding-top: 15px;
    padding-bottom: 10px;
    padding-right: 35px;
    padding-left: 15px;
    ${ props => props.isSelected ? `background: ${ Dark4 };` : `&:hover{ cursor: pointer;background: ${ WerfenColor }; color: ${ White }; svg{stroke: ${ White }} ` }
    transition: all 200ms;
`;

const OptionText = styled.p`
    margin-top: -27px;
    margin-left: 40px;
    margin-bottom: 0.5rem;
    display: none;
    @media screen and (min-width: 992px){
      display: inline-block;
    }
`;

const SidebarMenu = ( props ) => {
    const { optionSelected, selectOption, isNetworkAvailable } = props
    return (
        <StyledWrapper>
            <Option
                isSelected={ optionSelected === "settings" }
                onClick={ () => selectOption( "settings" ) }
            >
                <FeatherIconWrapper
                    width="30px"
                    Icon={ UserIcon }
                />
                <OptionText>Settings</OptionText>
            </Option>
            {
                !isElectron() &&
                process.env.REACT_APP_SEE_TICKETS === "1" &&
                props.session.ticketingUUID &&
                <Option
                    isSelected={ optionSelected === "tickets" }
                    onClick={ () => selectOption( "tickets" ) }
                >
                    <FeatherIconWrapper
                        width="30px"
                        Icon={ TicketsIcon }
                    />
                    <OptionText>Tickets</OptionText>
                </Option>
            }
            {
                isElectron() &&
                <Option
                    isSelected={ optionSelected === "downloading" }
                    onClick={ () => selectOption( "downloading" ) }
                >
                    <FeatherIconWrapper
                        width="30px"
                        Icon={ DownloadManagerIcon }
                    />
                    <OptionText>DownloadManager</OptionText>
                </Option>
            }
            {
                isElectron() &&
                <Option
                    isSelected={ optionSelected === "offline" }
                    onClick={ () => selectOption( "offline" ) }
                >
                    <FeatherIconWrapper
                        width="30px"
                        Icon={ AvailableOfflineIcon }
                    />
                    <OptionText>Available Offline</OptionText>
                </Option>
            }
            {
                isNetworkAvailable && <Option
                    isSelected={ optionSelected === "favorites" }
                    onClick={ () => selectOption( "favorites" ) }
                >
                    <FeatherIconWrapper
                        width="30px"
                        Icon={ HeartIcon }
                    />
                    <OptionText>Favorites</OptionText>
                </Option>
            }
        </StyledWrapper>
    )
}

const mapStateToProps = ( state ) => ({
    isNetworkAvailable: state.sensors.isNetworkAvailable,
    isServerReachable: state.sensors.isServerReachable,
    session: state.session
})

export default connect( mapStateToProps, {} )( SidebarMenu );